import React from "react";
import { Link } from "react-router-dom";
import { HardHat } from "lucide-react";

// Shared shell for the public access pages (matches the login page look).
export default function AccessShell({ children, testid }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-10" data-testid={testid}>
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 mb-6 justify-center">
          <div className="h-11 w-11 rounded-xl bg-primary flex items-center justify-center shadow">
            <HardHat className="h-6 w-6 text-white" />
          </div>
          <span className="text-xl font-head font-extrabold tracking-tight">PrüfDoc Pro</span>
        </div>
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8 fade-up">{children}</div>
        <div className="text-center mt-5">
          <Link to="/login" className="text-sm font-medium text-primary hover:underline" data-testid="access-back-to-login">
            Zurück zur Anmeldung
          </Link>
        </div>
      </div>
    </div>
  );
}
